import useBreakpoints, { Breakpoint } from "../../../hooks/useBreakpoints";
import { Headline, HeadlineLevel } from "../Headline";
import { CardVariant, type CardCommonProps } from "./Card.type";

interface CardHeaderProps extends Pick<CardCommonProps, "title" | "subtitle"> {
    level: HeadlineLevel;
    variant: CardVariant;
    isDisabled?: boolean;
}

export const CardHeader = (props: CardHeaderProps) => {
    const { getStyleBasedOnBreakpoint } = useBreakpoints();

    const isHorizontal = props.variant === CardVariant.HORIZONTAL;
    const textAlign = isHorizontal ? getStyleBasedOnBreakpoint(Breakpoint.MD, "text-left") : "";
    const titleColor = props.isDisabled ? "text-stone-500" : "text-forest-green-800 group-hover:text-forest-green-900";
    const subtitleColor = props.isDisabled ? "text-stone-500" : "text-stone-1000";

    return (
        <div className="gap-xxs flex flex-col">
            <Headline
                level={props.level}
                className={`text-xxl leading-none ${titleColor} text-center ${textAlign} `}
            >
                {props.title}
            </Headline>

            {props.subtitle && <p className={`${subtitleColor} text-l text-center ${textAlign}`}>{props.subtitle}</p>}
        </div>
    );
};
